<ng-container *transloco="let t">
	<mat-toolbar class="mat-elevation-z2" color="primary">
		<button #btnSideNavToggle (click)="onToolbarMenuToggle()" mat-icon-button>
			<mat-icon>menu</mat-icon>
		</button>
	</mat-toolbar>

	<mat-sidenav-container class="sidebar-container">
		<mat-sidenav [class.sidebar-close]="!isSidebarOpen" [class.sidebar-open]="isSidebarOpen" [mode]="mobile ? 'over' : 'side'" id="sideNav" opened="true">
			@if (!mobile && isSidebarOpen) {
				<mat-toolbar>
					<mat-toolbar-row>
						<span><h2>Web-Portal</h2></span>
					</mat-toolbar-row>
				</mat-toolbar>
			}
			<mat-nav-list>
				@if (!mobile && isSidebarOpen) {
					@if (userProfile) {
						@if (userProfile.username) {
							<div>
								<div class="avatar">
									<mat-icon>account_circle</mat-icon>
									<!--<div class="row align-items-center"><fa-icon [icon]="fauser"></fa-icon></div>-->
									<p>{{ userProfile.username }}</p>
								</div>
							</div>
						}
					}
					<mat-divider></mat-divider>
				}

				<mat-list-item [routerLink]="['/dashboard']" title="{{ t('dashboard') }}">
					<mat-icon>home</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('sideboard.dashboard') }}
					</span>
				</mat-list-item>

				<mat-divider></mat-divider>

				@if (!mobile && isSidebarOpen) {
					<div>
						<h2 matSubheader>{{ t('sideboard.functions') }}</h2>
					</div>
				}
				<mat-list-item [routerLink]="['/realestates']" title="{{ t('realestates.realestates') }}">
					<mat-icon>apartment</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('realestates.realestates') }}
					</span>
				</mat-list-item>

				<mat-list-item [routerLink]="['/realestates/wuseldusel']" title="{{ t('realestates.realestate') }}">
					<mat-icon>group</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('realestates.realestate') }}
					</span>
				</mat-list-item>

				<mat-list-item [routerLink]="['/uvi']" title="{{ t('sideboard.uvi') }}">
					<mat-icon>speed</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('sideboard.uvi') }}
					</span>
				</mat-list-item>

				<mat-list-item [routerLink]="['/#']" title="{{ t('permissions.permissions') }}">
					<mat-icon>tune</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('permissions.permissions') }}
					</span>
				</mat-list-item>

				<mat-divider></mat-divider>

				<mat-list-item [routerLink]="['/settings']" title="{{ t('settings.settings') }}">
					<mat-icon>settings</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('settings.settings') }}
					</span>
				</mat-list-item>

				<mat-list-item (click)="onLogout()" title="{{ t('sideboard.logout') }}">
					<mat-icon>logout</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('sideboard.logout') }}
					</span>
				</mat-list-item>

				<!--
        <p>{{ screen_width }}</p>
        -->
				<mat-divider></mat-divider>
				<!--
        <mat-list-item (click)="toggleTheme()">
          <mat-icon>lightbulb</mat-icon>
          <span class="ms-1 d-none d-sm-inline" [class.hidden-text]="!isSidebarOpen">
            {{darkTheme ? 'Dark-Mode' : 'Light-Mode'}}
          </span>
        </mat-list-item>
        -->
				<!--<mat-checkbox (change)="toggleTheme($event)">enabled LightTheme</mat-checkbox>-->
				<mat-list-item (click)="onToolbarMenuToggle()" class="bottomStick">
					<mat-icon>{{ isSidebarOpen ? 'arrow_left' : 'arrow_right' }}</mat-icon>
					<span [class.hidden-text]="!isSidebarOpen" class="ms-1 d-none d-sm-inline">
						{{ t('sideboard.hideSidebar') }}
					</span>
				</mat-list-item>
			</mat-nav-list>
		</mat-sidenav>
		<mat-sidenav-content #mainContainer [ngStyle]="{ 'margin-left.px': contentMargin }" id="mainContainer">
			<router-outlet></router-outlet>
			<app-footer></app-footer>
		</mat-sidenav-content>
	</mat-sidenav-container>
</ng-container>
